module.exports = __webpack_public_path__ + "img/doc1.f7c6ddbd.png";